import type { ReactNode } from 'react'
import { useLanguage } from '@/localization'

interface PageHeaderProps {
  title: string
  subtitle?: string
  children?: ReactNode
}

/** Consistent page banner used across the modern (Variant-A) inner pages. */
export default function PageHeader({ title, subtitle, children }: PageHeaderProps) {
  const { t } = useLanguage()

  return (
    <div className="relative overflow-hidden bg-slate-deep text-white">
      <div className="absolute inset-0 tex-grass opacity-10" />
      <div className="absolute inset-x-0 bottom-0 h-2 bg-grass-dark" />
      <div className="relative max-w-7xl mx-auto px-4 py-14 text-center">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-3">{t(title)}</h1>
        {subtitle && <p className="text-white/70 text-lg max-w-2xl mx-auto">{t(subtitle)}</p>}
        {children && <div className="mt-6">{children}</div>}
      </div>
    </div>
  )
}
